
export default {
  props: {
    introduction: {
      type: String,
      default: "",
    },
    instruction: {
      type: String,
      default: "",
    },
    sponsors: {
      type: String,
      default: "",
    },
  },
  computed: {
    getNotice() {
      const note = this.introduction.split("\n\n");
      return {
        content: note[0],
        notice: note[1],
      };
    },
    getInstruction() {
      return this.instruction.replaceAll("&nbsp;", " ");
    },
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
    };
  },
};
